import { MobileSymptomFormsComponent } from "./mobiledSymptomForms";

export const MobileSymptomForms = MobileSymptomFormsComponent;
